/**
 * The Master Sheet's Check changes dialog (2026-10-09, Max for Tram) — the shared ChangeCheckDialog,
 * told what a Master Sheet row is called and how it is found. The dialog itself is written once, for
 * this screen and the SAP Ship Doc both.
 */
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import ChangeCheckDialog from './ChangeCheckDialog';

/* Built per language (2026-10-21): the noun, the column heads and the placeholder are read by the dialog
   as they are drawn, so they are this screen's own strings in the reader's language. */
const masterSheetCfg = (t) => ({
  noun: t('xMaster.chgNoun'),
  reading: t('xMaster.chgReading'),
  groupField: 'Factory',
  groupAll: t('xMaster.chgGroupAll'),
  searchKeys: ['HNX_PO', 'SAP_Code', 'Description', 'Customer_PO', 'Destination'],
  searchPlaceholder: t('xMaster.chgSearch'),
  columns: [
    { label: t('xMaster.chgColFactory'), cell: (x) => x.id.Factory },
    { label: 'HNX PO', cell: (x) => x.id.HNX_PO },
    { label: t('xMaster.chgColSapCode'), cell: (x) => x.id.SAP_Code },
    { label: t('xMaster.chgColDescription'), cls: 'sp-chg-desc',
      cell: (x) => (x.id.Description ? <>{x.id.Description}{x.id.Color ? <em> · {x.id.Color}</em> : null}</> : null) },
    { label: 'Customer PO#', cell: (x) => x.id.Customer_PO },
    { label: t('xMaster.chgColDestination'), cls: 'sp-chg-desc', cell: (x) => x.id.Destination },
    { label: t('xMaster.chgColMonth'), cell: (x) => (x.id.Month && x.id.Year ? `${x.id.Month}/${x.id.Year}` : null) },
  ],
  size: (x, fmt) => (
    <>
      {t('xMaster.chgPcs', { n: fmt('Quantity', x.id.Quantity) })}
      {x.id.Total_At_Vendor !== null && x.id.Total_At_Vendor !== undefined
        ? <> · {x.id.Currency || ''} {fmt('Total_At_Vendor', x.id.Total_At_Vendor)}</> : null}
    </>
  ),
  fileName: 'Master_sheet_changes.xlsx',
});

export default function MasterSheetChanges({ api, fmt, onClose }) {
  const { t } = useTranslation();
  // Memoised on `t`, which changes with the language: the dialog filters its list with `cfg` in a useMemo.
  const cfg = useMemo(() => masterSheetCfg(t), [t]);
  return <ChangeCheckDialog base={`${api}/master-sheet/changes`} fmt={fmt} cfg={cfg} onClose={onClose} />;
}
